import styles from "./index.module.scss";
import cn from "classnames";

const CalcFormLayoutGroup = ({
  children,
  mode = "vertical",
  offset,
  offsetBottom,
}) => {
  return (
    <div
      className={cn(
        styles.wrapper,
        styles[mode],
        styles[`offset-${offset}`],
        styles[`offsetBottom-${offsetBottom}`]
      )}
    >
      {children}
    </div>
  );
};

export default CalcFormLayoutGroup;
